<template>
    <div class="verify-signup-form">
        <h2>Account Verified</h2>
        <div>Please <router-link to="/login">Login</router-link></div>
    </div>
</template>

<script>
    export default {
        mounted() {
            this.$store.dispatch('users/verifyUser', this.$route.params.token);
        }
    };
</script>

<style lang="scss">
    .verify-signup-form {
        * {
            display: block;
            margin: auto;
            margin-bottom: $space-32;

            width: $space-256;
        }

        *:last-child {
            margin-bottom: 0;
        }
    }
</style>